import AWS from "aws-sdk";
import dayjs from "dayjs";

const accessKey = process.env.REACT_APP_AWS_ACCESSKEY_ID;
const accessSecret = process.env.REACT_APP_AWS_ACCESSKEY_SECRET;
const region = process.env.REACT_APP_AWS_REGION;
const bucketName = process.env.REACT_APP_AWS_BUCKET_NAME;

const s3 = new AWS.S3({
  accessKeyId: accessKey,
  secretAccessKey: accessSecret,
  region: region,
});

const s3Controller2 = {
  s3Upload: (fileContent, path) => {
    // const file = fileContent.name.split(".")
    const params = {
      Bucket: bucketName,
      Key: path + "/" + fileContent.name, // 폴더가 없으면 만들어서 넣는다.
      Body: fileContent,
    //   ContentType: fileContent.type
    };
    return new Promise((resolve,reject)=>s3.upload(params, (err,data)=>{
      if (err) resolve(err) //reject를 사용하지 않고 resolve를 사용하는 것은 에러 후 팝업으로 계속진행 여부를 묻기 위함. err발생 시 for문은 중단된다.
      resolve(data)
    }))
  },
  s3List: (prefix) => {
    const params = {
      Bucket: bucketName,
      Prefix: prefix,
    }
    return new Promise((resolve,reject)=>s3.listObjects(params, (err,data)=>{
      if (err) reject(err)
      resolve(data)
    }))
  },
  s3DeleteFile: (key) => {
    const params = {
      Bucket: bucketName,
      Key: key,
    }
    return new Promise((resolve,reject)=>s3.deleteObject(params, (err,data)=>{
      if(err) reject(err)
      resolve(data)
    }))
  },
  s3DeleteFiles: (objects) => {
    const params = {
      Bucket: bucketName,
      Delete: {
        Objects:objects
      }
    }
    return new Promise((resolve,reject)=>s3.deleteObjects(params, (err,data)=>{
      if(err) reject(err)
      resolve(data)
    }))
  },
};

export default s3Controller2;
